import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import './ApplierForm.css';
import { IoChevronBackOutline } from "react-icons/io5";
import axios from 'axios'; // استدعاء axios مباشرة بدلاً من apiClient

const ApplierForm = () => {
  const [formData, setFormData] = useState({
    full_name: "",
    phone_number: "",
    date_of_birth: "",
    current_profession: "",
    education_qualification: "",
    specialization: "",
    graduation_year: "",
  });

  const [cvFile, setCvFile] = useState(null);
  const [fileName, setFileName] = useState("");
  const [jobId, setJobId] = useState(null);

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [popupType, setPopupType] = useState('success');
  const [popupMessage, setPopupMessage] = useState('');

  const [searchParams] = useSearchParams();

  useEffect(() => {
    const id = searchParams.get('job_id');
    if (id) {
      setJobId(id);
    }
  }, [searchParams]);

  const handleInputChange = (e) => {
    const { name } = e.target;
    let { value } = e.target;
    if (name === 'phone_number') {
      // دعم تحويل الأرقام العربية والفارسية إلى أرقام لاتينية ثم الإبقاء على الأرقام فقط
      const normalizeToAsciiDigits = (s) => s
        .replace(/[\u0660-\u0669]/g, (c) => String(c.charCodeAt(0) - 0x0660))
        .replace(/[\u06F0-\u06F9]/g, (c) => String(c.charCodeAt(0) - 0x06F0));
      value = normalizeToAsciiDigits(value).replace(/\D/g, '');
    }
    setFormData(prevState => ({ ...prevState, [name]: value }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setCvFile(file);
      setFileName(file.name);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!cvFile) {
      setPopupMessage("يرجى إرفاق ملف السيرة الذاتية (CV).");
      setPopupType('failure');
      setShowPopup(true);
      return;
    }
    setIsSubmitting(true);

    const submissionData = new FormData();

    Object.keys(formData).forEach(key => {
      submissionData.append(key, formData[key]);
    });

    if (jobId) {
      submissionData.append('job_id', jobId);
    }

    submissionData.append('cv_file', cvFile);

    try {
      // ==== هذا هو الجزء الذي تم تعديله ====
      // استخدام axios مباشرة مع تحديد الرابط الكامل
      // هذا يتجاوز أي إعدادات افتراضية قد تسبب المشكلة
      const response = await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}/api/v1/job-applications`,
          submissionData
      );

      if (response.status === 201) {
        setPopupMessage('تم إرسال طلبك بنجاح!');
        setPopupType('success');
        setFormData({
          full_name: "",
          phone_number: "",
          date_of_birth: "",
          current_profession: "",
          education_qualification: "",
          specialization: "",
          graduation_year: "",
        });
        setCvFile(null);
        setFileName("");
      }
    } catch (error) {
      // تسجيل خطأ أكثر تفصيلاً في console المتصفح
      console.error("Error submitting application:", error.response?.data || error.message);
      setPopupMessage('حدث خطأ أثناء إرسال الطلب. تأكد من أن كل الحقول صحيحة وأن الملف من نوع PDF.');
      setPopupType('failure');
    } finally {
      setIsSubmitting(false);
      setShowPopup(true);
    }
  };

  const handleClosePopup = () => setShowPopup(false);

  return (
      <div className="form-wrapper">
        <div className="form-container">
          <h2 className="text-center mb-4"> سجّل بياناتك</h2>
          <form dir="rtl" method="POST" onSubmit={handleSubmit}>
            <div className="form-row row">
              <div className="form-group col-md-6">
                <label>الاسم بالكامل</label>
                <input type="text" className="form-control" name="full_name" value={formData.full_name} onChange={handleInputChange} required />
              </div>
              <div className="form-group col-md-6">
                <label>رقم الهاتف</label>
                <input type="tel" className="form-control" name="phone_number" value={formData.phone_number} onChange={handleInputChange} inputMode="numeric" pattern="^[0-9]{7,15}$" minLength={7} maxLength={15} title="يرجى إدخال رقم هاتف صحيح (أرقام فقط بين 7 و15 خانة)" required />
              </div>
            </div>
            <div className="form-row row">
              <div className="form-group col-md-6">
                <label>تاريخ الميلاد</label>
                <input type="date" className="form-control" name="date_of_birth" value={formData.date_of_birth} onChange={handleInputChange} required />
              </div>
              <div className="form-group col-md-6">
                <label>المهنة الحالية</label>
                <input type="text" className="form-control" name="current_profession" value={formData.current_profession} onChange={handleInputChange} required />
              </div>
            </div>
            <div className="form-row row">
              <div className="form-group col-md-3">
                <label>المؤهل الدراسى</label>
                <input type="text" className="form-control" name="education_qualification" value={formData.education_qualification} onChange={handleInputChange} required />
              </div>
              <div className="form-group col-md-3">
                <label>التخصص</label>
                <input type="text" className="form-control" name="specialization" value={formData.specialization} onChange={handleInputChange} required />
              </div>
              <div className="form-group col-md-3">
                <label>سنة التخرج</label>
                <input type="number" className="form-control" name="graduation_year" value={formData.graduation_year} onChange={handleInputChange} required />
              </div>
            </div>
            <div>
              <div className="form-row row">
                <div className="form-group col-md-12">
                  <label htmlFor="fileInput" className="btn btn-file">تحميل CV (PDF فقط)</label>
                  <input id="fileInput" type="file" accept=".pdf" style={{ display: "none" }} onChange={handleFileChange} required />
                </div>
              </div>
              {fileName && <p>الملف المحدد: {fileName}</p>}
            </div>
            <div className="form-row row">
              <div className="col-md-3 d-flex justify-content-center">
                <button type="submit" className="btn submit-btn" disabled={isSubmitting}>
                  {isSubmitting ? 'جاري الإرسال...' : 'ارسل طلبك'}
                  <IoChevronBackOutline />
                </button>
              </div>
            </div>
          </form>
          {showPopup && (
              <div className="popup" onClick={handleClosePopup}>
                <div
                    className={`popup-content ${popupType === 'success' ? 'popup-success' : 'popup-failure'}`}
                    onClick={(e) => e.stopPropagation()}
                >
                  <span className="close" onClick={handleClosePopup}>&times;</span>
                  <p>{popupMessage}</p>
                </div>
              </div>
          )}
        </div>
      </div>
  );
};

export default ApplierForm;